module.exports = __webpack_public_path__ + "img/Jump Casting19.c860c208.jpg";